import { z } from 'zod';
import { LABELS } from '../constants';
import { requiredString, validateMobile } from '../helper';

const { EMAIL, FIRST_NAME, LAST_NAME, MOBILE_NUMBER } = LABELS;

export const addJointAppFormSchema = z.object({
  firstName: requiredString(FIRST_NAME),
  lastName: requiredString(LAST_NAME),
  email: requiredString(EMAIL).email(),
  mobile: requiredString(MOBILE_NUMBER).and(validateMobile),
});

export type AddJointAppFormType = z.infer<typeof addJointAppFormSchema>;
